<template>
  <div class="foters">
    <div class="form">
      <a-form :layout="formLayout" >
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="角色名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入角色名称"
                v-model="conditionLike.roleName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="角色类型"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                :allowClear="true"
                v-model="conditionLike.roleType"
                placeholder="请选择角色类型"
              >
                <a-select-option v-for="item in usrRTList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item 
              label="角色状态"    
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :allowClear="true"
                v-model="conditionLike.roleStatus"
                placeholder="请选择角色状态"
              >
                <a-select-option v-for="item in usrRSList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="padding-top: 2.4%;margin-left: 12px;">
            <a-button class="btone" @click="queryList(1)">查询</a-button>
            <a-button class="bttwo" @click="userAdd()">新增</a-button>
          </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <div>
        <a-table
          :columns="columns"
          :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
          :data-source="tableData"
          :pagination="false"
          :loading="Tableloading"
          :rowKey="
            (record, index) => {
              return record.id
            }
          "
          bordered
          size="small"
        >
        <div slot="index" slot-scope="text, record, index">
          {{index + (pageNum-1) * pageSize + 1}}
        </div>
        <div slot="roleType" slot-scope="text">
          {{ text.roleType | DictionaryFilter("ROLE_TYPE") }}
        </div>
        <div slot="roleStatus" slot-scope="text">
          <span v-if="text.roleStatus == 1"><a-badge color="cyan" /></span>
          <span v-else-if="text.roleStatus == 2"><a-badge color="red" /></span>
          {{ text.roleStatus | DictionaryFilter("ROLE_STATUS") }}
        </div>
        <div slot="action" slot-scope="text">
            <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick" style="text-align: center;">
        <a-menu-item key="1"> <a href="javascript:;" class="modification" @click="modification(text)"
            >编辑</a
          ></a-menu-item>
        <a-menu-item key="2">  <a href="javascript:;" class="delete" @click="deleteClick(text)"
            >删除</a
          > </a-menu-item>
        <a-menu-item key="3">
          <a href="javascript:;" class="modification" @click="up(text)">{{
            text.roleStatus == 1 ? '禁用' : '启用'
          }}</a></a-menu-item>
         <a-menu-item key="4">
            <a href="javascript:;" class="modification" @click="AssignUsers(text)"
              >分配用户</a
            ></a-menu-item>
         <a-menu-item key="5">
          <a href="javascript:;" class="delete" @click="allocation(text)">分配菜单</a
         ></a-menu-item>
     
      </a-menu>
      <a-button style="margin-left: 8px" class="btaction"> 更多操作 <a-icon type="down" /> </a-button>
    </a-dropdown>
    </div>
    </a-table>
    </div>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPage }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <addModal
      v-if="visible"
      :visible="visible"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></addModal>
  </div>
</template>

<script>
import {
  queryRoleList,
  deleteRole,
  updateRoleStatus,
} from '@/api/api.js'
import { DictionaryService } from '@common/services/dictionary.service'
import addModal from './role-add-modal'
export default {
  name: 'roleManagement',
  components: {
    addModal: addModal,
  },
  data() {
    return {
      formLayout: 'horizontal',
      conditionLike: {
        roleType: undefined,
        roleName: '',
        roleStatus: undefined,
      },
      Tableloading:false,
      tableData: [],
      usrRTList: [],
      usrRSList: [],
      querying : false,
      columns : [
          { title: "序号",align: "center", dataIndex: 'index',width:23, key : 'index', ellipsis: true,scopedSlots: { customRender: 'index' }},
          { title: '角色名称',align: "center", dataIndex: 'roleName',width:107, key : 'roleName', ellipsis: true},
          { title: '角色类型',align: "center", width:60, key : 'roleType', ellipsis: true ,scopedSlots: {customRender: 'roleType'}},
          { title: '角色状态', align: "center", width: 50, key: 'roleStatus', ellipsis: true, scopedSlots: { customRender: 'roleStatus'}},
          { title: '备注', align: "center",dataIndex: 'remark',width:180, key : 'remark', ellipsis: true },
          { title: "操作",align: "center", key: "action",width:80, align: "center",  scopedSlots: { customRender: "action" } },
      ],
      // // 分页相关
      pageNum : 1,
      pageSize : 10,
      totalRows : null,
        totalPage: '',
      //新增弹框
      visible:false,
      userData: {},
      type:'',
    }
  },
  activated() {
      //查询数据字典
      DictionaryService.getAllNeedDic(["ROLE_TYPE","ROLE_STATUS"]).then((res) => {
        this.usrRTList = DictionaryService.getOptions("ROLE_TYPE");
        this.usrRSList = DictionaryService.getOptions("ROLE_STATUS");

        //查询列表
        this.queryList();
      });
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {}
    },
    buttonItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {}
    },
  },
  methods: {
    //路由跳转
    allocation(content) {
      this.$router.push({
        path: "/home/system/role-manage/role-allocation",
        query: { id: content.id },
      });
    },


    // 分页修改
    changePageFn(event) {
      this.pageNum = event
      this.queryList()
    },
    handleMenuClick(e) {
    },
    //启用禁用处理
    up(data) {
      let status = data.roleStatus
      this.$confirm({
        title: status == 1 ? '确认禁用吗？' : '确认启用吗？',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.staing = true

          updateRoleStatus({ id: data.id }).then(
            (res) => {
              this.staing = false
              this.queryList()
              this.$message.success('设置成功')
            },
            (err) => {
              this.staing = false
              this.$message.error('设置失败')
            }
          )
        },
        onCancel: () => { },
      })
    },
    // 获取表格数据
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1
      this.Tableloading = true
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: '',
      }
      queryRoleList({ pageParam: pageParam, content: this.conditionLike }).then(
        (res) => {
          this.Tableloading = false
          this.tableData = res.content.rows
          this.totalRows = res.content.page.totalRows
          this.totalPage = Math.ceil(this.totalRows / this.pageSize)
        },
        (err) => {
          this.$message.error('查询失败')
          this.Tableloading = false
        }
      )
    },
    // 用户新增
    userAdd() {
      this.visible = true
      this.type = 'add'
      this.title = '角色新增'
    },
    // 关闭弹窗
    reflush() {
      this.visible = false
    },
    // 删除
    deleteClick(text) {
      this.$confirm({
        title: '确定是否删除?',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.querying = true
          deleteRole({ id: text.id }).then(
            (res) => {
              this.querying = false
              this.queryList()
              this.$message.success('删除成功')
            },
            (err) => {
              this.querying = false
            }
          )
        },
        onCancel: () => { },
      })
    },
    // 编辑
    modification(data) {
      this.visible = true
      this.type = 'amend'
      this.userData = data
      this.title = '角色修改'
    },
    AssignUsers(data) {
      //配置跳转页面
      this.$router.push({
        path: '/home/system/role-manage/assignUsers',
        query: { id: data.id },
      })
    },
  }
}
</script>

<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  a {
    margin-left: 10px;
    color: #108ee9;
  }
  a:hover {
    color: #70b9cf;
  }
}


/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,.ant-select,.ant-form-item-control,.ant-form-item-control-wrapper{
  width: 160px;
}
.fw {
  width: 236px;
}
.oper{
  // flex: 1;
  width: 200px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1){
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1){
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1){
  width: 75px;
}
/deep/ .ant-col-18 {
  width: 58%;
}
/deep/ .ant-input-affix-wrapper {
  width: 131%;
}
</style>

